export default __webpack_public_path__ + "static/media/subscription3.5a4d20b4.png";